
define(
	'C3.ShoppingExtensions.Carousel'
,   [
		//'C3.ShoppingExtensions.Carousel.View',
		'C3.ShoppingExtensions.Carousel.Model'
	]
,   function (
		//CarouselView,
		Model
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			
			var layout = container.getComponent('Layout');
			//return new Router(container); 

			  /*var model = new Model()
		      , self = this;

		      model.fetch().done(function (res)
		      {
		      	console.log(res)
		        var view = new CarouselView
		        ({
		          application: layout.application
		        , model: model
		        });

		        view.showContent();
		      });*/
			

		}
	};
});
